import React, { useState } from "react"
import styled from "styled-components"
import { MdSearch } from "react-icons/md"
import { connectSearchBox } from "react-instantsearch-dom"
import { SearchResult } from "../search-result/search-result"
import OutsideClickHandler from "react-outside-click-handler"
import Tippy from "@tippy.js/react"
import "tippy.js/dist/tippy.css"

const Search = connectSearchBox(({ refine, currentRefinement }) => {
  const [searchResultIsOpen, setSearchResultIsOpen] = useState(false)

  const handleSearch = event => {
    refine(event.currentTarget.value)
    setSearchResultIsOpen(true)
  }

  const handleKeyDown = event => {
    if (event.key === "Enter") {
      setSearchResultIsOpen(true)
    }
  }

  return (
    <OutsideClickHandler onOutsideClick={() => setSearchResultIsOpen(false)}>
      <Wrapper>
        <Input
          value={currentRefinement}
          onChange={handleSearch}
          type="search"
          placeholder="Search for documents"
          onKeyDown={handleKeyDown}
        />
        <Tippy arrow={false} content="Search">
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
          <span tabIndex="0" style={{ height: "100%" }}>
            <Button onClick={() => setSearchResultIsOpen(true)}>
              <MdSearch />
            </Button>
          </span>
        </Tippy>
      </Wrapper>
      <SearchResult
        active={currentRefinement.length > 2 && searchResultIsOpen}
      />
    </OutsideClickHandler>
  )
})

export default Search

const Wrapper = styled.div`
  height: 32px;
  overflow: hidden;
  border-radius: 1px;
  display: flex;
  align-items: center;
  border: 1px solid #444;
  border-radius: 2px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`

const Input = styled.input`
  font-size: 16px;
  width: 100%;
  height: 100%;
  background-color: #000;
  border: none;
  color: #fff;
  padding: 0 10px;
`

const Button = styled.button`
  font-size: 22px;
  line-height: 16px;
  background-color: #444;
  color: #999;
  border: none;
  height: 100%;
  padding: 0 25px;
  vertical-align: middle;
  cursor: pointer;

  &:hover {
    color: #ccc;
  }
`
